<template>
  <div class="upload">
    <QSpinner size="sm" color="grey-7" v-if="fileUploadLoading" />
    <div v-else @click.stop="onClickUpload">
      <div class="filecheckmark" v-if="file">
        <i class="uiw-font-filecheckmark" style="color: var(--primary-color); margin-left: -10px" />
      </div>
      <div class="file-upload" v-if="!file" style="background-color: var(--primary-color-background)">
        <i class="uiw-font-file-upload" style="color: var(--primary-color); margin-left: -10px" @click.stop="onClickUpload" />
      </div>
    </div>
    <div class="filename">{{ file ? file.fileName : '' }} &nbsp;</div>
    <a class="action" v-if="file" @click="onClickDelete">Delete</a>
    <span class="action" v-if="!file" @click.stop="onClickUpload">Upload document</span>
    <div style="display: none">
      <QFile
        ref="file"
        bg-color="grey-1"
        filled
        @input="onUpload"
        accept=".jpg, .pdf, .jpeg, .png, image/*"
        max-file-size="10240000"
        @rejected="onRejected"
      >
      </QFile>
    </div>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
import { mapMutations, mapGetters } from 'vuex';
import { QFile, QSpinner } from 'eclipx.ui';
import MutateSaveFile from '../../../graphql/mutations/MutateSaveFile';
import { GLOBAL_ERROR } from '../../../components/GlobalError/GlobalError';

export default {
  name: 'UploadFile',
  props: {
    file: Object,
    name: String
  },
  data: function () {
    return {
      fileUploadLoading: false
    };
  },
  components: { QFile, QSpinner },
  methods: {
    onClickDelete() {
      this.$emit('deleteFile', { name: this.name });
    },
    onClickUpload() {
      if (this.file) {
        return;
      }
      this.$refs.file.pickFiles();
    },
    onRejected: function (rejectedEntries) {
      alert('File size should be under 10MB.');
    },
    onUpload: async function (file) {
      this.fileUploadLoading = true;
      const response = await this.$apollo
        .mutate({
          mutation: MutateSaveFile,
          variables: {
            file: file
          }
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      if (response?.data?.saveFile) {
        const fileObj = {
          fileName: response.data.saveFile.fileName,
          uuid: response.data.saveFile.uuid,
          mimeType: response.data.saveFile.mimeType
        };
        this.$emit('onUpload', { ...fileObj, name: this.name });
      }

      this.fileUploadLoading = false;
    }
  }
};
</script>

<style lang="sass" scoped>
.upload
  position: relative;
  border: 1px solid #E0E0E0;
  text-align: center;
  padding: 10px;
input[type=file]
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
.filecheckmark, .file-upload
  width: 40px;
  height: 40px;
  padding: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 7px;
.filecheckmark
  background: #EDF9E6;
.file-upload
  background: #E9F3FE;
.filename
  font-size: 10px;
  padding-bottom: 0;
  height: 20px;
.action
  cursor: pointer;
  font-size: 10px;
  color: var(--primary-color);
  text-decoration: underline;
</style>
